import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '@core/auth';
import { AppLicense } from '@core/licenses';

export const licenseGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const requestedLicense = route.params?.['license'];
  return true
  // return Object.values(AppLicense).includes(requestedLicense)
  //   && authService.allAvailableLicenses.includes(requestedLicense);
};
